import React, { FunctionComponent, useState, useEffect } from 'react';
import Slider from 'react-slick';
import { useSlickReady } from '../../../hooks/useSlickReady';
import type { Mag } from '../../../types/toppage';

interface Props {
  magCategories: Mag[];
  activeTab: number;
  onTabChange: (categoryId: number) => void;
}

export const Presentation: FunctionComponent<Props> = ({
  magCategories,
  activeTab,
  onTabChange
}) => {
  const activeCategory = magCategories.find(cat => cat.id === activeTab);
  const ready = useSlickReady();
  const [isSp, setIsSp] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsSp(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <section className="sitetop-recruitment" id="from_mag">
      <div className="sitetop-pickup-nav">
        <h2 className="sitetop-pickup-title">
          READY TO FASHION MAG
          <span className="sitetop-pickup-sub">
            ファッション業界で働く&quot;今&quot;をひも解くマガジン
          </span>
        </h2>
        <a
          href="https://www.readytofashion.jp/mag/"
          target="_blank"
          className="sitetop-pickup-companies gtm-button-view-count"
          data-event-name='button on screen'
          data-event='click'
          data-category='topcontent'
          data-value='from_mag_to_all'
        >
          記事一覧へ
        </a>
      </div>

      <div className="sitetop-mag-container">
        <div className="sitetop-mag-category-tabs">
          {magCategories.map((category, index) => (
            <button
              key={category.id}
              onClick={() => onTabChange(category.id)}
              className={`sitetop-mag-category-tab ${activeTab === category.id ? 'active' : ''} gtm-button-view-count`}
              data-event-name='button on screen'
              data-event='click'
              data-category='topcontent'
              data-value={`from_mag_tab${index + 1}`}
            >
              {category.name}
            </button>
          ))}
        </div>

        {activeCategory && activeCategory.articles.length > 0 && (
          <>

            {!isSp && ready && (
              <Slider key={activeTab} {...settings} className="sitetop-mag-slider">
                {activeCategory.articles.map((article, index) => (
                  <div key={article.id} className="sitetop-mag-slide-item">
                    <a
                      href={article.url}
                      target="_blank"
                      className="sitetop-mag-article-card gtm-mag-view-count"
                      data-event-name='mag on screen'
                      data-event='click'
                      data-category='topcontent'
                      data-value={`from_mag${(index % 5) + 1}`}
                      data-state={`from_mag_tab${activeTab}`}
                      data-articleId={article.id}
                    >
                      <div className="sitetop-mag-article-image">
                        <img src={article.image_url} alt={article.title} />
                      </div>
                      <div className="sitetop-mag-article-title">
                        {article.title}
                      </div>
                    </a>
                  </div>
                ))}
                {activeCategory.category_url && (
                  <div className="sitetop-mag-slide-item">
                    <a
                      href={activeCategory.category_url}
                      target="_blank"
                      className="sitetop-mag-more-card gtm-button-view-count"
                      data-event-name='button on screen'
                      data-event='click'
                      data-category='topcontent'
                      data-value={`from_mag_more_tab${activeTab}`}
                    >
                      <div className="sitetop-mag-more-inner">
                        <div className="sitetop-mag-more-catchcopy">
                          {activeCategory.catchcopy || 'ファッション業界の\nリアルな声を覗いてみる'}
                        </div>
                        <span className="sitetop-mag-more-link">
                          もっと見る
                        </span>
                      </div>
                    </a>
                  </div>
                )}
              </Slider>
            )}

            {isSp && (
              <>
                <div className="sitetop-mag-list">
                  {activeCategory.articles.map((article, index) => (
                    <a
                      key={article.id}
                      href={article.url}
                      target="_blank"
                      className="sitetop-mag-list-item gtm-mag-view-count"
                      data-event-name='mag on screen'
                      data-event='click'
                      data-category='topcontent'
                      data-value={`from_mag${(index % 5) + 1}`}
                      data-state={`from_mag_tab${activeTab}`}
                      data-articleId={article.id}
                    >
                      <div className="sitetop-mag-list-thumbnail">
                        <img src={article.image_url} alt={article.title} />
                      </div>
                      <div className="sitetop-mag-list-title">
                        {article.title}
                      </div>
                    </a>
                  ))}
                </div>
                {activeCategory.category_url && (
                  <a
                    href={activeCategory.category_url}
                    target="_blank"
                    className="sitetop-mag-more-card gtm-button-view-count"
                    data-event-name='button on screen'
                    data-event='click'
                    data-category='topcontent'
                    data-value={`from_mag_more_tab${activeTab}`}
                  >
                    <div className="sitetop-mag-more-catchcopy">
                      {activeCategory.catchcopy || 'ファッション業界の\nリアルな声を覗いてみる'}
                    </div>
                    <span className="sitetop-mag-more-link">
                      もっと見る
                    </span>
                  </a>
                )}
              </>
            )}
          </>
        )}

        {activeCategory && activeCategory.articles.length === 0 && (
          <p className="text-muted">まだ記事が登録されていません</p>
        )}
      </div>
      <a
        href="https://www.readytofashion.jp/mag/"
        className="sitetop-pickup-spcompanies"
      >
        記事一覧へ
      </a>
    </section>
  );
};
